import { useEffect, useState } from 'react';
import Front from '@frontapp/plugin-sdk';
import { WebViewContext } from '@frontapp/plugin-sdk/dist/webViewSdkTypes';

interface FrontContextData {
  emails: string[];
  loading: boolean;
  conversationType: 'none' | 'single' | 'multi';
  context: WebViewContext | null;
}

export function useFrontContext(): FrontContextData {
  const [context, setContext] = useState<WebViewContext | null>(null);
  const [loading, setLoading] = useState(true);
  const [emails, setEmails] = useState<string[]>([]);

  useEffect(() => {
    const subscription = Front.contextUpdates.subscribe((ctx) => {
      setContext(ctx);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (context?.type === 'singleConversation') {
      context.listRecipients().then((recipientList) => {
        const allEmails = recipientList.results
          .map((recipient) => recipient.handle)
          .filter((handle): handle is string => !!handle);
        setEmails([...new Set(allEmails)]);
      });
    }
  }, [context]);

  let conversationType: 'none' | 'single' | 'multi' = 'none';

  if (context?.type === 'singleConversation') {
    conversationType = 'single';
  } else if (context?.type === 'multiConversations') {
    conversationType = 'multi';
  }

  return { emails, loading, conversationType, context };
}
